import {classNames, layout, PushButton, theme, ViewActions, ViewHeader, ViewHeaderItem} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface VendingViewHeaderProps {
    title?: string;
    onBack?: () => any;
    button?: string;
    onButtonClick?: () => any;
}

export function VendingViewHeader({title, onBack, button, onButtonClick}: VendingViewHeaderProps) {
    const {t} = useLocalization();
    const fullTitle = title ? `${t("appName")}: ${title}` : t("appName");
    return (
        <ViewHeader className={theme.lessContrast}>
            <ViewHeaderItem className={classNames(layout.paddingMedium, styles.branding)}>
                {fullTitle}
            </ViewHeaderItem>
            <ViewActions>
                {onBack && (
                    <PushButton onClick={onBack} className={styles.button}>
                        {t("Back")}
                    </PushButton>
                )}
                {button && (
                    <PushButton onClick={onButtonClick} className={styles.button}>
                        {button}
                    </PushButton>
                )}
            </ViewActions>
        </ViewHeader>
    )
}


const styles = stylesheet({
    branding: {
        fontSize: "2em",
        fontWeight: 300,
        color: "var(--color-primary)"
    },
    button: {
        alignSelf: "center"
    }
});
